import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import { TDistributorTypeForm } from "../types/distributorTypes.types";

type DistributorTypeFormProps = {
  formik: FormikProps<TDistributorTypeForm>;
};

export const DistributorTypeForm = ({ formik }: DistributorTypeFormProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CustomInput
        label="Nombre"
        error={
          formik.touched.name && formik.errors.name
            ? formik.errors.name
            : undefined
        }
        {...formik.getFieldProps("name")}
      />
      <CustomInput
        label="Valor Clave"
        error={
          formik.touched.keyValue && formik.errors.keyValue
            ? formik.errors.keyValue
            : undefined
        }
        {...formik.getFieldProps("keyValue")}
      />
    </div>
  );
};
